import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const PRODUCTS = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "shares_bond", label: "Shares & Bond" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function InvestmentJourney() {
  const [configOpen, setConfigOpen] = useState(true);
  const [viewType, setViewType] = useState("on_screen");
  const [products, setProducts] = useState(() =>
    PRODUCTS.reduce((acc, p) => ({ ...acc, [p.key]: true }), {})
  );
  const [investor, setInvestor] = useState("all_selected");
  const [source, setSource] = useState("all");
  const [category, setCategory] = useState("all_selected");
  const [period, setPeriod] = useState("since_inception");
  const [applying, setApplying] = useState(false);

  const toggleProduct = (key) => {
    setProducts((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: fetch investment journey report
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Investment Journey</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item"><NavLink to="/reports/investment-journey">Reports</NavLink> /</li>
                    <li className="breadcrumb-item active">Investment Journey</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Report Configuration (collapsible) */}
        <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <button
            type="button"
            className="card-header bg-white border-bottom d-flex align-items-center gap-2 w-100 text-start p-3"
            style={{ fontWeight: "600", color: "#0f172a", border: "none", cursor: "pointer" }}
            onClick={() => setConfigOpen(!configOpen)}
            aria-expanded={configOpen}
          >
            <i className={`fa fa-${configOpen ? "minus" : "plus"}-square-o`} style={{ fontSize: "1.1rem", color: TEAL }} aria-hidden />
            Report Configuration
          </button>
          {configOpen && (
            <div className="card-body p-4">
              <div className="mb-4">
                <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "8px" }}>
                  View Type :
                </label>
                <div className="d-flex flex-wrap gap-3">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      value="on_screen"
                      checked={viewType === "on_screen"}
                      onChange={() => setViewType("on_screen")}
                      style={{ accentColor: TEAL, width: 18, height: 18 }}
                    />
                    <span style={{ fontSize: "15px", color: "#475569" }}>On Screen</span>
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      value="pdf"
                      checked={viewType === "pdf"}
                      onChange={() => setViewType("pdf")}
                      style={{ accentColor: TEAL, width: 18, height: 18 }}
                    />
                    <span style={{ fontSize: "15px", color: "#475569" }}>PDF</span>
                  </label>
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "8px" }}>
                  Choose Products:
                </label>
                <div className="d-flex flex-wrap gap-3">
                  {PRODUCTS.map((p) => (
                    <label key={p.key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={products[p.key]}
                        onChange={() => toggleProduct(p.key)}
                        style={{ accentColor: TEAL, width: 16, height: 16 }}
                      />
                      <span style={{ fontSize: "15px", color: "#475569" }}>{p.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "8px" }}>
                  Filter :
                </label>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label small text-muted">Investor :</label>
                    <select
                      className="form-select form-select-sm"
                      value={investor}
                      onChange={(e) => setInvestor(e.target.value)}
                      style={inputBorderStyle}
                    >
                      <option value="all_selected">All Selected</option>
                      <option value="primary">Primary</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small text-muted">Source :</label>
                    <select
                      className="form-select form-select-sm"
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                      style={inputBorderStyle}
                    >
                      <option value="all">All</option>
                      <option value="managed">Managed Data</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small text-muted">Category :</label>
                    <select
                      className="form-select form-select-sm"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      style={inputBorderStyle}
                    >
                      <option value="all_selected">All Selected</option>
                      <option value="equity">Equity</option>
                      <option value="debt">Debt</option>
                      <option value="hybrid">Hybrid</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small text-muted">Period :</label>
                    <select
                      className="form-select form-select-sm"
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                      style={inputBorderStyle}
                    >
                      <option value="since_inception">Since Inception</option>
                      <option value="current_month">Current Month</option>
                      <option value="last_one_month">Last One Month</option>
                      <option value="current_fy">Current FY</option>
                      <option value="last_fy">Last FY</option>
                      <option value="last_one_year">Last One Year</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center pt-2">
                <button
                  type="button"
                  className="btn px-5 py-2"
                  style={{
                    background: TEAL,
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "15px",
                  }}
                  onClick={handleApply}
                  disabled={applying}
                >
                  {applying ? "Applying…" : "Apply"}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Message section - No data available */}
        <div
          className="rounded d-flex align-items-center justify-content-center py-5"
          style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "12px" }}
        >
          <div className="text-center">
            <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem", color: "#f59e0b" }} aria-hidden />
            <span style={{ color: "#64748b", fontSize: "15px" }}>No data available for this period.</span>
          </div>
        </div>
      </div>
    </>
  );
}
